import domElementPath from "dom-element-path";

export default {
  init() {
    $("body").on("click", function (e) {
      if (!$(e.target).parents(".redirect-popup").length) {
        $(".redirect-popup").hide();
      }
    });

    $("#lang-select-menu").change(function () {
      window.location.href = $(this).val();
    });

    $(".redirect-popup-in-sub-title").click(function () {
      $(".redirect-popup").hide();
    });

    $(".open-3d-html").click(function () {
      $(".wrap-3d-html").addClass("open");
    });

    $(".wrap-3d-html").click(function () {
      $(".wrap-3d-html").removeClass("open");
    });

    if ($("#main-search-input").val()) {
      $(".search-form-holder").addClass("active");
    }

    $("#main-search-input").focus(function () {
      if ($("#main-search-input").val()) {
        $(".search-form-holder").addClass("active");
        return;
      }

      if ($(".search-form-holder").hasClass("active")) {
        $(".search-form-holder").removeClass("active");
      } else {
        $(".search-form-holder").addClass("active");
      }
    });

    $(".map-in a").click(function () {
      var country = $(this).attr("title");
      console.log(country);
      $(".offices-item .office-item").removeClass("active");
      $("html, body").animate(
        {
          scrollTop: $("#" + country).offset().top - 400 + "px",
        },
        1000,
        "swing"
      );

      $("#" + country)
        .parents(".office-item")
        .addClass("active");
    });

    $(".site-main-nav > ul:first-child > li:first-child ").addClass("full");
    // JavaScript to be fired on all pages
    $("body").on("click", function (e) {
      if (!$(e.target).parents(".wrap-menu").length) {
        $(".menu-item-has-children").removeClass("open");
      }
    });

    bannerImage();
    $(window).resize(function () {
      bannerImage();
    });

    function bannerImage() {
      if ($(window).width() < 900) {
        $(".top-image img").attr("src", $(".top-image img").data("tablet"));
      }
    }

    this.initForms();
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },

  initForms() {
    $(".hbspt-form").each((index, el) => {
      let $el = $(el);

      let platform_id = $el.data("platform-id");
      let form_id = $el.data("form-id");
      let segmentName = $el.data("segment");
      let target = ($el.attr('id') ? '#'+$el.attr('id') : '') || domElementPath(el);

      console.log(`${target} ||| Platform ID: ${platform_id}, Form ID: ${form_id};`);

      if (!platform_id || !form_id) {
        return;
      }

      // const target2 = $("div.wrap-form-item > div.hbspt-form").length
      //   ? "div.wrap-form-item > div.hbspt-form"
      //   : $(".loop-form .hbspt-form").length
      //   ? ".loop-form .hbspt-form"
      //   : "#assistance .hbspt-form";

      window.hbspt.forms.create({
        portalId: platform_id,
        formId: form_id,
        target: target,
        css: "",
        onFormReady: (form) => {
          $(form).find('input[name="bermad_segment"]').val(segmentName).change();
          $(form)
            .find('input[name="bermad_website_url"]')
            .val(window.location.href)
            .change();
        },
        onFormSubmit: (form) => {
          if (form_id == "b9a17a47-f549-4e78-8121-f2e6b7cfcc2d") {
            window.location.href = $(".download-html").data("link");
          }
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js